import { render, staticRenderFns } from "./HomepageCard.vue?vue&type=template&id=5983a969&scoped=true&lang=pug&"
import script from "./HomepageCard.vue?vue&type=script&lang=js&"
export * from "./HomepageCard.vue?vue&type=script&lang=js&"
import style0 from "./HomepageCard.vue?vue&type=style&index=0&id=5983a969&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5983a969",
  null
  
)

export default component.exports